// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__5phZW","modal":"Modal_modal__scwdS"};